var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showStatusBar
    ? _c(
        "div",
        { staticClass: "lbv-status-bar" },
        [
          _c(
            "b-alert",
            {
              attrs: {
                fade: "",
                dismissible: "",
                show: _vm.successDismiss,
                variant: "success",
              },
              on: {
                dismissed: function ($event) {
                  _vm.successDismiss = 0
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.success) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              attrs: {
                fade: "",
                dismissible: "",
                show: _vm.warningDismiss,
                variant: "warning",
              },
              on: {
                dismissed: function ($event) {
                  _vm.warningDismiss = 0
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.warning) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              attrs: {
                fade: "",
                dismissible: "",
                show: _vm.error != "",
                variant: "danger",
              },
              on: {
                dismissed: function ($event) {
                  _vm.error = ""
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }